import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {AdminRootPageComponent} from './admin-root.page';

const routes: Routes = [
  {
    path: '',
    component: AdminRootPageComponent
  },
  {
    path: 'attendee',
    loadChildren: () => import('../admin-attendee/admin-attendee.module').then(m => m.AdminAttendeePageModule)
  },
  {
    path: 'bookings',
    loadChildren: () => import('../admin-bookings/admin-bookings.module').then(m => m.AdminBookingsPageModule)
  },
  {
    path: 'system',
    loadChildren: () => import('../admin-system/admin-system.module').then(m => m.AdminSystemPageModule)
  },
  {
    path: 'guest_new',
    loadChildren: () => import('../admin-new-guest/admin-new-guest.module').then(m => m.AdminNewGuestPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRootPageRoutingModule {
}
